import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

export default class extends Controller {
  static targets = ["map"]
  static values = {
    radius: { type: Number, default: 0 },
    center: Array
  }

  connect() {
    setTimeout(() => this._drawCircle(), 0)
  }

  _drawCircle() {
    if (!this.radiusValue || !this.hasMapTarget || !this.hasCenterValue) return
    const [lat, lng] = this.centerValue
    if (lat == null || lng == null) return

    const lmap = this.application
      .getControllerForElementAndIdentifier(this.mapTarget, "leaflet-map")
      ?.map
    if (!lmap) return

    L.circle([lat, lng], {
      radius: this.radiusValue,
      color: "#3b82f6",
      weight: 2,
      dashArray: "6 4",
      fillColor: "#3b82f6",
      fillOpacity: 0.08
    }).addTo(lmap)
  }
}
